import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { startMarquee, updateMarquee } from './line';

import uk from '../locales/uk.json';
import ru from '../locales/ru.json';

const ALIAS = {
  uk: 'uk',
  ua: 'uk',
  ru: 'ru',
  rus: 'ru',
};

const LANG_LABELS = {
  uk: 'Ua',
  ru: 'Ru',
};

const DEBUG = Boolean(import.meta.env.DEV);

i18next
  .use(LanguageDetector)
  .init({
    fallbackLng: 'uk',
    debug: DEBUG,
    saveMissing: false,
    parseMissingKeyHandler: () => '',
    resources: {
      uk: { translation: uk },
      ru: { translation: ru },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })
  .then(() => {
    const currentLang = mapLng(i18next.language);

    updateContent();
    updateSelectedLangUI(currentLang);
    updateLangOptionsVisible(currentLang);
    setHtmlLang(currentLang);
    initLangButtons();
    startMarquee();

    i18next.on('languageChanged', lng => {
      const mappedLang = mapLng(lng);

      updateContent();
      updateSelectedLangUI(mappedLang);
      updateLangOptionsVisible(mappedLang);
      setHtmlLang(mappedLang);
      updateMarquee();
    });
  });

function mapLng(lng) {
  const normalizedLng = (lng || '').toLowerCase();
  const baseLng = normalizedLng.split('-')[0];

  return ALIAS[normalizedLng] || ALIAS[baseLng] || 'uk';
}

function updateContent() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.dataset.i18n;
    el.textContent = i18next.t(key, { defaultValue: '' });
  });

  document.querySelectorAll('[data-i18n-aria-label]').forEach(el => {
    const key = el.dataset.i18nAriaLabel;
    el.setAttribute('aria-label', i18next.t(key, { defaultValue: '' }));
  });
}

function updateSelectedLangUI(lang) {
  document.querySelectorAll('.selected-lang').forEach(selectedLang => {
    const arrowIcon = selectedLang.querySelector('svg');

    selectedLang.textContent = `${LANG_LABELS[lang]} `;

    if (arrowIcon) {
      selectedLang.appendChild(arrowIcon);
    }
  });

  document.querySelectorAll('[data-lang]').forEach(btn => {
    const btnLang = mapLng(btn.dataset.lang);
    const isCurrent = btnLang === lang;

    btn.setAttribute('aria-pressed', String(isCurrent));
  });
}

function updateLangOptionsVisible(currentLang) {
  document.querySelectorAll('[data-lang]').forEach(btn => {
    const btnLang = mapLng(btn.dataset.lang);
    const isCurrent = btnLang === currentLang;

    btn.setAttribute('aria-pressed', String(isCurrent));

    const li = btn.closest('li');

    if (li) {
      li.hidden = isCurrent;
      btn.tabIndex = isCurrent ? -1 : 0;
      btn.setAttribute('aria-hidden', String(isCurrent));
    }

    if (!li) {
      btn.tabIndex = 0;
      btn.removeAttribute('aria-hidden');
    }
  });
}

function setHtmlLang(lang) {
  document.documentElement.lang = lang === 'ru' ? 'ru' : 'uk';
}

function changeLang(code) {
  const lang = mapLng(code);

  i18next.changeLanguage(lang).then(() => {
    document.querySelectorAll('.lang-menu').forEach(menu => {
      menu.removeAttribute('open');
    });

    document.querySelector('.selected-lang')?.focus();
  });
}

function initLangButtons() {
  document.querySelectorAll('[data-lang]').forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();

      changeLang(btn.dataset.lang);
    });
  });
}